module.exports = __webpack_public_path__ + "static/img/2en.aca07a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/2en.png
// module id = 76OQ
// module chunks = 0